import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { debounceTime, filter, Subject, Subscription } from 'rxjs';
import { RGBAColor } from '@inmoment/the-kitchen/src/lib/Pickers/ColorPicker/ColorPicker.model';

import { AppSharedModule } from 'app/app-shared.module';
import { ChartCustomColorService } from 'app/modules/dashboard/services/chart-custom-color.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { Utils } from '../../../../../utils/utils';

@EnableClassTelemetry()
@Component({
  selector: 'app-color-box',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './color-box.component.html',
  styleUrls: ['./color-box.component.scss'],
})
export class ColorBoxComponent implements OnInit, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() canDelete;
  @Input() canEdit;
  @Input() set color(colorString) {
    this.rgbaColor = ChartCustomColorService.colorStringToRgbaColor(colorString);
  }

  @Output() colorChange = new EventEmitter<string>();
  @Output() colorDelete = new EventEmitter<void>();

  rgbaColor: RGBAColor;
  colorChange$ = new Subject<RGBAColor>();
  colorChangeSub: Subscription;

  ngOnInit(): void {
    this.colorChangeSub = this.colorChange$
      .pipe(
        debounceTime(250),
        filter((curr) => !Utils.deepEquals(this.rgbaColor, curr))
      )
      .subscribe((value) => this.onColorChanged(value));
  }

  ngOnDestroy(): void {
    this.colorChangeSub?.unsubscribe();
  }

  onColorChanged(color) {
    if (!this.canEdit) {
      return;
    }

    this.rgbaColor = color;
    this.colorChange.emit(ChartCustomColorService.rgbaColorToColorString(this.rgbaColor));
  }
}
